import React from "react";
import "../../styles/PagesStyles/AboutUs.css";
import {  trackEvent } from "../../utils/google-analytics";
import { useNavigate } from "react-router-dom";
import aboutImg from "../../assets/images/about us/aboutImg.png";
import mission from '../../assets/images/about us/mission.png';
import d from '../../assets/images/about us/data.png';
import s from '../../assets/images/about us/security.png';
import e from '../../assets/images/about us/file.png';
import r from '../../assets/images/about us/target.png';
import thinkImage from '../../assets/images/about us/vission.png';
import enterpriseIcon from "../../assets/images/about us/Group.png";
import securityIcon from "../../assets/images/about us/lock.png";
import partnershipIcon from "../../assets/images/about us/hand icon.png";
import globalIcon from "../../assets/images/about us/earth.png";
import usePageTitle from "../../hooks/usePageTitle";


const AboutSection = () => {
  const navigate = useNavigate();

  const missionItems = [
    { id: 1, text: "Data-Centric Design", checked: false, icon: d },
    { id: 2, text: "Security & Governance", checked: false, icon: s },
    { id: 3, text: "Enterprise Readiness", checked: false, icon: e },
    { id: 4, text: "Real-World Outcomes", checked: true, icon: r },
  ];

  const visionItems = [
    { id: 1, text: "Data-Centric Approach", desc: "Building systems around quality data for reliable AI outcomes" },
    { id: 2, text: "Agentic Systems", desc: "Creating autonomous AI agents that work independently within governed frameworks" },
    { id: 3, text: "Enterprise Confidence", desc: "Enabling safe adoption with robust governance and scalability" },
  ];

  const capabilityItems = [
    { id: 1, title: "Data-First Engineering", desc: "We design Generative AI systems grounded in structured, unstructured, and multimodal enterprise data to ensure accuracy, reliability, and relevance.", icon: d },
    { id: 2, title: "Enterprise-Grade Delivery", desc: "We build, deploy, and support production-ready AI systems that operate reliably within real enterprise environments.", icon: enterpriseIcon },
    { id: 3, title: "Security & Governance by Design", desc: "Security, compliance, and responsible AI practices are embedded into every system from architecture to deployment.", icon: securityIcon },
    { id: 4, title: "Long Term Partnership Focus", desc: "We combine Indian engineering depth with global governance and enterprise delivery standards.", icon: partnershipIcon },
    { id: 5, title: "Global Operating Model", desc: "We combine Indian engineering depth with global governance and enterprise delivery standards.", icon: globalIcon },
  ];
  const handleBookStrategyCall = () => {
    // Track the event
    trackEvent("cta_click", {
      page: "About Page",
      button_text: "Contact Us",
    });

    // Navigate to contact page
    navigate("/contact");
  };

  const handleCapabilityClick = (title) => {
    trackEvent("capability_click", {
      page: "About Page",
      capability: title,
    });
  };

  return (
    <>
      <div className="about-page-container">
        <section className="about-wrapper">
          <div className="about-container">

            {/* LEFT CONTENT */}
            <div className="about-content">
              <h2 className="about-title">About us</h2>

              <h3 className="about-heading">
                Enterprise Generative AI. Engineered in
                <br />
                Nashik. Delivered Globally.
              </h3>

              <div className="about-text-container">
                <p className="about-text">
                  Combat Solutions is a{" "}
                  <span className="highlight">global enterprise AI company</span>{" "}
                  specializing in production-ready generative AI systems for regulated industries.
                </p>

                <p className="about-text">
                  We bridge the gap between{" "}
                  <span className="highlight">AI experimentation and enterprise deployment</span>,
                  delivering secure, governed, and scalable AI solutions.
                </p>

                <p className="about-text">
                  Founded in Nashik with operations spanning Mumbai to Sydney, we serve enterprises that
                  demand the highest standards of{" "}
                  <span className="highlight">security, compliance, and responsible AI</span>.
                </p>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="about-image-section">
              <div className="about-image-mask">
                <img src={aboutImg} alt="Enterprise AI Solutions" />
              </div>
            </div>

          </div>
        </section>


        <section className="mission-section">
          <div className="mission-container">
            <div className="mission-layout">

              {/* LEFT CONTENT */}
              <div className="mission-content">
                <h2 className="mission-title">Our mission</h2>
                <div className="mission-underline"></div>
                <p className="mission-statement">
                  We exist to help enterprises responsibly transform complex data into actionable
                  intelligence by designing and deploying secure, governed, and production-grade
                  Generative AI systems that create real, measurable business outcomes.
                </p>

                {/* ICON POINTS */}
                <div className="mission-icons-grid">
                  <div className="mission-icon-item"
                    onClick={() =>
                      trackEvent("mission_icon_click", {
                        page: "About Page",
                        mission: "Data-Centric Design",
                      })
                    }
                  >
                    <img src={d} alt="Data-Centric Design" />
                    <span>Data-Centric Design</span>
                  </div>

                  <div className="mission-icon-item"
                    onClick={() =>
                      trackEvent("mission_icon_click", {
                        page: "About Page",
                        mission: "Security & Governance",
                      })
                    }
                  >
                    <img src={s} alt="Security & Governance" />
                    <span>Security & Governance</span>
                  </div>

                  <div className="mission-icon-item"
                    onClick={() =>
                      trackEvent("mission_icon_click", {
                        page: "About Page",
                        mission: "Enterprise Readiness",
                      })
                    }>
                    <img src={e} alt="Enterprise Readiness" />
                    <span>Enterprise Readiness</span>
                  </div>

                  <div className="mission-icon-item"
                    onClick={() =>
                      trackEvent("mission_icon_click", {
                        page: "About Page",
                        mission: "Real-World Outcomes",
                      })
                    }>
                    <img src={r} alt="Real-World Outcomes" />
                    <span>Real-World Outcomes</span>
                  </div>
                </div>
              </div>

              {/* RIGHT IMAGE */}
              <div className="mission-image-wrapper">
                <img src={mission} alt="Our Mission" />
              </div>

            </div>
          </div>
        </section>

        <section className="vision-section">
          <div className="vision-container">
            <div className="vision-layout">

              {/* LEFT: IMAGE */}
              <div className="vision-image-wrapper">
                <img
                  src={thinkImage}
                  alt="Our Vision"
                  className="vision-image"
                />
              </div>

              {/* RIGHT: TEXT CONTENT */}
              <div className="vision-content">
                <h2 className="vision-title">Our Vision</h2>
                <div className="vision-underline"></div>
                <p className="vision-statement">
                  Our vision is to build data-centric and agentic Generative AI systems that enterprises
                  can confidently adopt, govern, and scale enabling AI to operate responsibly across
                  industries, workflows, and geographies.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="capabilities-section">
          <div className="capabilities-container">

            {/* Header */}
            <div className="capabilities-header">
              <h2 className="capabilities-title">Capabilities</h2>
              <div className="title-underline"></div>
            </div>

            {/* TOP ROW – 3 cards */}
            <div className="capabilities-grid capabilities-grid--top">
              {capabilityItems.slice(0, 3).map((item) => (
                <div
                  className="capability-card"
                  key={item.id}
                  onClick={() => handleCapabilityClick(item.title)}
                >
                  <div className="capability-icon-container">
                    <img src={item.icon} alt={item.title} className="capability-icon" />
                  </div>
                  <h3 className="capability-title">{item.title}</h3>
                  <p className="capability-description">{item.desc}</p>
                </div>
              ))}
            </div>

            {/* BOTTOM ROW – staggered (D between A & B, E between B & C) */}
            <div className="capabilities-grid--bottom">
              {capabilityItems.slice(3, 5).map((item) => (
                <div className="capability-card" key={item.id}>
                  <div className="capability-icon-container">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="capability-icon"
                    />
                  </div>
                  <h3 className="capability-title">{item.title}</h3>
                  <p className="capability-description">{item.desc}</p>
                </div>
              ))}
            </div>

          </div>
        </section>

        <section className="cta-simple-section">
          <div className="cta-gradient-effect"></div>
          <div className="cta-simple-container">
            <h2 className="cta-simple-title">
              Believe in transforming complexity into outcomes that work in the real world with us!
            </h2>
            <button className="cta-simple-button"
              onClick={handleBookStrategyCall}>
              Contact Us
            </button>
          </div>
        </section>
      </div>

    </>
  );
};

export default AboutSection;